const HOUR = '([0-1]\\d|[2][0-3])';
const MINUTE = '([0-5]\\d)';
const SECOND = MINUTE;
const DATE = '(\\d{4})-([0]\\d|[1][0-2])-([0-2]\\d|[3][0-1])';
const TIME = `${HOUR}:${MINUTE}(:${SECOND})?(\\.(\\d+))?([+-]${HOUR}:${MINUTE}|[Z])?`;
export const DEFAULT = 'default';
export const SHORT = 'short';
export const NUMERIC = 'numeric';
export const VALID_DATE_FORMATS = {
  DEFAULT,
  SHORT,
  NUMERIC
};
export const ISO_DATE = new RegExp(`^${DATE}[Z]?$`);
export const ISO_DATETIME = new RegExp(`^${DATE}T${TIME}$`);
export const TIME_TOKENS = new Set(['Z', '+', '-']);
export const VALID_FORMATS = new Set(Object.values(VALID_DATE_FORMATS)).add(undefined);
//# sourceMappingURL=consts.js.map